import React, { useCallback, useEffect, useMemo, useState } from "react";
import * as RB from "react-bootstrap";
import DataTable from "react-data-table-component";

import Swal from "sweetalert2";
import EditIcon from "@mui/icons-material/Edit";
import {
  Delete,
  Visibility,
  Download,
  PagesRounded,
  ShieldMoon,
} from "@mui/icons-material";
import * as utils from "../Utils/comman";
import moment from "moment";
import { useDispatch, useSelector } from "react-redux";
import { fetchUserProfile } from "../reducers/userProfileSlice";
import "../assets/scss/styles/timeline.css";
import { useParams, useSearchParams } from "react-router-dom";
import { numberFormat } from "../Utils/comman";

function InvoicePage(props) {
  const [searchParams] = useSearchParams();
  const token = searchParams.get("id");
  const [piData, setPiData] = useState([]);
  const [resStatus, setResStatus] = useState([]);
  const [status, setStatus] = useState("");
  const [note, setNote] = useState("");
  const [readNote, setReadNote] = useState("");
  const [errors, setErrors] = useState({});
  const [isLargeScreen, setIsLargeScreen] = useState(window.innerWidth >= 1200);
  const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth < 1200);
  const [orderProducts, setOrderProducts] = useState([]);

  const dispatch = useDispatch();
  const fields = [
    { label: "Invoice No.", key: "invoice_no" },
    { label: "Delivery Note", key: "delivery_note" },
    { label: "Reference No. & Date.", key: "ref_no_date" },
    { label: "Buyer’s Order No.", key: "buyers_order_no" },
    { label: "Dispatch Doc No.", key: "dispacth_doc_no" },
    { label: "Dispatched through", key: "dispatched_through" },
    { label: "Dated", key: "invoice_date" },
    { label: "Mode/Terms of Payment", key: "payment_terms" },
    { label: "Other References", key: "other_ref" },
    { label: "Dated", key: "buyers_order_date" },
    { label: "Delivery Note Date", key: "delivery_note_date" },
    { label: "Destination", key: "destination" },
  ];

  const discounts = [
    {
      key: "quantity_discount_per",
      value: "quantity_discount",
      label: "Quantity Discount",
      extra: "Less:",
    },
    {
      key: "cash_discount_per",
      value: "cash_discount",
      label: "Cash Discount",
      extra: "Less:",
    },
    {
      key: "special_discount_per",
      value: "special_discount",
      label: "Special Discount",
      extra: "Less:",
    },
    {
      key: "freight_amount",
      value: "freight_amount",
      label: "Freight Amount",
      extra: "",
    },
    {
      key: "insurance_per",
      value: "insurance_amount",
      label: "Insurance",
      extra: "",
    },
    { key: "igst_per", value: "igst", label: "IGST", extra: "" },
    { key: "sgst_per", value: "sgst", label: "SGST", extra: "" },
    { key: "cgst_per", value: "cgst", label: "CGST", extra: "" },
    { key: "rounding", label: "Rounding", extra: "Less", value: "roundoff" },
  ];

  const userProfile = useSelector((state) => state?.userProfile?.userProfile);
  const userId = userProfile?.id;
  const rowData = props?.rowData;
  const isRelevantUser =
    userId === rowData?.ceo_id ||
    userId === rowData?.cfo_id ||
    userId === rowData?.rsm_id ||
    userId === rowData?.channel_partner_id;

  const approvalNoteKeys = [
    { key: "rsm_approve_note", label: "RSM Note", id: rowData?.rsm_id },
    {
      key: "channel_partner_approve_note",
      label: "Channel Partner Note",
      id: rowData?.channel_partner_id,
    },
    { key: "cfo_approve_note", label: "CFO Note", id: rowData?.cfo_id },
    { key: "ceo_approve_note", label: "CEO Note", id: rowData?.ceo_id },
  ];

  const isApprovalStatusZero = () => {
    if (userId === rowData?.ceo_id) {
      return rowData?.ceo_approve_status === "0";
    } else if (userId === rowData?.cfo_id) {
      return rowData?.cfo_approve_status === "0";
    } else if (userId === rowData?.rsm_id) {
      return rowData?.rsm_approve_status === "0";
    } else if (userId === rowData?.channel_partner_id) {
      return rowData?.channel_partner_approve_status === "0";
    }
    return false;
  };

  const getApprovalNote = () => {
    if (userId === rowData?.rsm_id && rowData?.rsm_approve_note !== null) {
      console.log(rowData?.rsm_approve_note, "This is ta");
      return rowData?.rsm_approve_note;
    } else if (
      userId === rowData?.channel_partner_id &&
      rowData?.channel_partner_approve_note !== null
    ) {
      return rowData?.channel_partner_approve_note;
    } else if (
      userId === rowData?.cfo_id &&
      rowData?.cfo_approve_note !== null
    ) {
      return rowData?.cfo_approve_note;
    } else if (
      userId === rowData?.ceo_id &&
      rowData?.ceo_approve_note !== null
    ) {
      return rowData?.ceo_approve_note;
    }
    return "";
  };

  // Use useEffect to set the note state based on the approval note
  useEffect(() => {
    const approvalNote = getApprovalNote();

    setReadNote(approvalNote);
  }, [userId, rowData]);

  useEffect(() => {
    const handleResize = () => {
      setIsLargeScreen(window.innerWidth >= 1200);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    const handleResize = () => {
      setIsSmallScreen(window.innerWidth < 1200);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    fetchOrderDetails();
  }, []);

  const fetchOrderDetails = async () => {
    try {
      utils
        .callAPI("get", `/sales/orderdetails/${token}`)
        .then((res) => {
          if (typeof res !== "undefined") {
            const products = [...res?.Proforma_invoice_products];
            products.map((product) => {
              product.size = (product.size * 1).toFixed(2);
              product.total_qty = (
                product.total_qty ? parseFloat(product.total_qty) : 0
              ).toFixed(2);
            });

            setOrderProducts(products);
            setPiData(res);
            setResStatus(res);
          } else {
            setPiData([]);
            setResStatus([]);
          }
        })
        .catch((err) => {
          setPiData([]);
          setResStatus([]);
        });

      /*const response = await fetch(
        `http://tms.vura.ae/dev/Vura_API_Server/src/api/sales/orderdetails/${token}`
      );

      if (!response.ok) {
        throw new Error("Network response was not ok");
      }
      const data = await response.json();
      setPiData(data.data);
      setResStatus(data.data);
      // console.log("Data fetched and set:", data.data); // Debugging*/
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const validate = () => {
    const newErrors = {};
    if (status === "2" && !note) {
      newErrors.note = "Comment is required";
    }
    return newErrors;
  };

  const sendStatus = useCallback(async () => {
    const validationErrors = validate();
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }
    if (status) {
      const formData = new FormData();
      formData.append("id", piData.id);
      formData.append("status", status);
      formData.append("token", token);
      formData.append("remarks", note);

      try {
        utils
          .callAPI("post", `/sales/approve_pi_by_channel_partner`, formData)
          .then((res) => {
            if (typeof res !== "undefined") {
              setResStatus(res.data);
              fetchOrderDetails(token);

              Swal.fire({
                title: "Success!",
                text:
                  status === "1"
                    ? "The invoice has been approved."
                    : "The invoice has been rejected.",
                icon: "success",
                confirmButtonText: "OK",
              });
            } else {
              setResStatus([]);
              fetchOrderDetails(token);
            }
          })
          .catch((err) => {
            setResStatus([]);
          });

        /*const response = await fetch(
          "https://we.vura.ae/Vura_API_Server/src/api/sales/approve_pi_by_channel_partner",
          {
            method: "POST",
            body: formData,
          }
        );

        if (!response.ok) {
          throw new Error("Network response was not ok");
        }

        const data = await response.json();
        console.log("Response Data:", data.data.channel_partner_approve_status);
        setResStatus(data.data);
        fetchOrderDetails(token);

        Swal.fire({
          title: "Success!",
          text:
            status === "1"
              ? "The invoice has been approved."
              : "The invoice has been rejected.",
          icon: "success",
          confirmButtonText: "OK",
        });*/
        // Optionally, reset status or handle successful response
      } catch (error) {
        console.error("Error posting data:", error);
        Swal.fire({
          title: "Error!",
          text: "There was an error processing your request.",
          icon: "error",
          confirmButtonText: "OK",
        });
      }
    }
  }, [status, note, piData.id]);

  useEffect(() => {
    if (status) {
      sendStatus();
    }
  }, [status, sendStatus]);

  const handleAccept = (e) => {
    setStatus("1");
  };

  const handleReject = (e) => {
    setStatus("2");
  };

  return (
    <div className="section-body p-2">
      <RB.Card className="card mx-md-5 mx-2 p-2 mb-5 mt-2 border-0 bg-transparent">
        {/*<RB.Card.Header className="border-0">
          <h4>Performa Invoice</h4>
        </RB.Card.Header>*/}
        <RB.Card.Body className={"p-0 bg-transparent"}>
          <div className={"pi-invoice mb-5"}>
            <RB.Row className={"border bg-white"}>
              <RB.Col md={12} className={"py-2 text-center"}>
                <h6 className={"mb-0"}>PROFORMA TAX INVOICE</h6>
                <small>Issued under GST Invoice Rules</small>
              </RB.Col>
            </RB.Row>

            <RB.Row className={"border border-top-0 bg-white"}>
              <RB.Col md={4} className={"border-end py-2"}>
                <h6>
                  <strong>Supplier - Seller:</strong>
                </h6>
                <p className={"mb-0"}>
                  <strong>{piData.registered_office?.company_name}</strong>
                </p>
                <p className={"mb-0"}>
                  {piData.registered_office?.address}
                  <br />
                  {piData.registered_office?.city} -{" "}
                  {piData.registered_office?.pincode}
                </p>
                <p className={"mb-0"}>
                  <strong>State:</strong> {piData.registered_office?.state}
                </p>
                <RB.Row>
                  <RB.Col md={6}>
                    <strong>GSTIN:</strong> {piData.registered_office?.gstno}
                  </RB.Col>
                  {/*<RB.Col md={6}>
                    <strong>PAN:</strong> AABCS4338M
                  </RB.Col>*/}
                </RB.Row>

                {/*<RB.Row>
                  <RB.Col md={6}>
                    <strong>CIN:</strong> U26109TN1997PL037875
                  </RB.Col>
                  <RB.Col md={6}>
                    <strong>TAN:</strong> CHES05530A
                  </RB.Col>
                </RB.Row>*/}
              </RB.Col>
              <RB.Col md={4} className={"border-end py-2"}>
                <h6>
                  <strong>Recipient - Customer :</strong>
                </h6>
                <>
                  <p className={"mb-0"}>
                    <strong>{piData?.bill_to_companyName}</strong>
                  </p>
                  <p className={"mb-0"}>
                    {piData?.bill_to_company_address},<br />
                    {piData?.bill_to_company_district},<br />
                    {piData?.bill_to_company_city} -{" "}
                    {piData?.bill_to_company_pincode},<br />
                    {/*Ph. : BILL TO PHONE<br/>*/}
                  </p>
                  <p className={"mb-0"}>
                    <strong>State:</strong> {piData?.bill_to_company_state}
                  </p>
                  <p className={"mb-0"}>
                    <strong>GSTIN:</strong> {piData?.bill_to_gst_no}
                  </p>
                </>
              </RB.Col>
              <RB.Col md={4} className={"border1 py-2"}>
                <p className={"mb-0"}>
                  <strong>Proforma Invoice No.: </strong> {piData?.invoice_no}
                </p>
                <p className={"mb-0"}>
                  <strong>Proforma Invoice Date: </strong>{" "}
                  {moment(piData?.invoice_date).format("DD-MM-YYYY")}
                </p>
                <p className={"mb-0"}>
                  <strong>Sales Order No.: </strong>{" "}
                  {piData?.orderdata?.order_id}
                </p>
                <p className={"mb-0"}>
                  <strong>Sales Order Date: </strong>{" "}
                  {moment(piData?.order_date).format("DD-MM-YYYY")}
                </p>
                <p className={"mb-0"}>
                  <strong>Ref.: </strong> {piData?.emp_ref_no}
                </p>
                <RB.Row className={"border-top"}>
                  <RB.Col>
                    <p className={"mb-0"}>
                      <strong>Mode/Terms of Payment: </strong>{" "}
                      {piData?.payment_terms}
                    </p>
                    <p className={"mb-0"}>
                      <strong>Delivery Note: </strong> {piData?.delivery_note}
                    </p>
                    <p className={"mb-0"}>
                      <strong>Reference No. & Date: </strong>{" "}
                      {piData?.ref_no_date}
                    </p>
                    <p className={"mb-0"}>
                      <strong>Other References: </strong> {piData?.other_ref}
                    </p>
                  </RB.Col>
                </RB.Row>
              </RB.Col>
            </RB.Row>

            <RB.Row className={"border border-top-0 bg-white"}>
              <RB.Col md={4} className={"border-end py-2"}>
                <h6>
                  <strong>Destination Center:</strong>
                </h6>
                <>
                  <p className={"mb-0"}>
                    <strong>{piData?.location_data?.name}</strong>
                  </p>
                  <p className={"mb-0"}>
                    {piData?.location_data?.address},<br />
                    {/*{piData?.location_data?.district},<br/>*/}
                    {piData?.location_data?.city} -{" "}
                    {piData.location_data?.pincode},<br />
                    {piData.location_data?.state}
                  </p>
                </>
              </RB.Col>
              <RB.Col md={4} className={"border-end py-2"}>
                <h6>
                  <strong>Ship - To :</strong>
                </h6>
                <>
                  <p className={"mb-0"}>
                    <strong>{piData?.ship_to_companyName}</strong>
                  </p>
                  <p className={"mb-0"}>
                    {piData?.ship_to_company_address},<br />
                    {piData?.ship_to_company_city},<br />
                    {piData.ship_to_company_state} -{" "}
                    {piData.ship_to_company_pincode}
                  </p>
                </>
              </RB.Col>
              <RB.Col md={4} className={"border1 py-2"}>
                <p className={"mb-0"}>
                  <strong>Buyer’s Order No.: </strong> {piData?.buyers_order_no}
                </p>
                <p className={"mb-0"}>
                  <strong>Dated: </strong> {piData?.buyers_order_date}
                </p>
                <p className={"mb-0"}>
                  <strong>Dispatch Doc No.: </strong> {piData?.dispacth_doc_no}
                </p>
                <p className={"mb-0"}>
                  <strong>Delivery Note Date: </strong>{" "}
                  {piData?.delivery_note_date}
                </p>
                <p className={"mb-0"}>
                  <strong>Dispatched through: </strong>{" "}
                  {piData?.dispatched_through}
                </p>
                <p className={"mb-0"}>
                  <strong>Destination: </strong> {piData?.destination}
                </p>
              </RB.Col>
            </RB.Row>

            <RB.Row className={"border border-bottom-0 bg-white"}>
              <h5 className="mt-3">Products</h5>

              <div className={"table-responsive p-0"}>
                <RB.Table
                  bordered
                  hover
                  striped
                  className="border mb-0 table-sm table-invoice-products w-100"
                >
                  <thead>
                    <tr>
                      <th rowSpan={2}>S.No</th>
                      <th rowSpan={2}>Description of Goods</th>
                      <th className={"text-center"} rowSpan={2}>
                        UOM
                      </th>
                      <th className={"text-center"} rowSpan={2}>
                        HSN
                      </th>
                      <th className={"text-center"}>CGST</th>
                      <th className={"text-center"}>SGST</th>
                      <th className={"text-center"}>IGST</th>
                      <th className={"text-center"} rowSpan={2}>
                        Rate / UOM
                      </th>
                      <th colSpan={3} className={"text-center"}>
                        Quantity
                      </th>
                      <th className={"text-center"} rowSpan={2}>
                        Gross Value
                      </th>
                      <th className={"text-center"} colSpan={4}>
                        Discounts
                      </th>
                      <th className={"text-center"} rowSpan={2}>
                        Net Value
                      </th>
                    </tr>
                    <tr>
                      <th className={"text-center"}>%</th>
                      <th className={"text-center"}>%</th>
                      <th className={"text-center"}>%</th>
                      <th className={"text-center"}>In UOM</th>
                      <th className={"text-center"}>Pack Size</th>
                      <th className={"text-center"}>Total Qty(Kg)</th>
                      <th className={"text-center"}>Trade (%)</th>
                      <th className={"text-center"}>Quantity (%)</th>
                      <th className={"text-center"}>Cash (%)</th>
                      <th className={"text-center"}>Special (%)</th>
                    </tr>
                  </thead>

                  <tbody>
                    {orderProducts.length &&
                      orderProducts.map((product, index) => (
                        <tr key={index}>
                          <td className={"text-center"}>{index + 1}</td>
                          <td>{product.product_name}</td>
                          <td className={"text-center"}>
                            {(product.mou || "").toUpperCase()}
                          </td>
                          <td className={"text-center"}>
                            {product.hsn_code || ""}
                          </td>
                          <td className={"text-end"}>
                            {parseFloat(product.cgst || 0).toFixed(2)}
                          </td>
                          <td className={"text-end"}>
                            {parseFloat(product.sgst || 0).toFixed(2)}
                          </td>
                          <td className={"text-end"}>
                            {parseFloat(product.igst || 0).toFixed(2)}
                          </td>
                          <td className={"text-end"}>
                            {numberFormat(product.rate)}
                          </td>
                          <td className={"text-end"}>{product.qty}</td>
                          <td className={"text-end"}>
                            {parseFloat(product.size).toFixed(2)}
                          </td>
                          <td className={"text-end"}>{product.total_qty}</td>
                          <td className={"text-end"}>
                            {numberFormat(product.gross_value)}
                          </td>
                          <td className={"text-end"}>
                            {parseFloat(product.discount_per || 0).toFixed(2)}
                          </td>
                          <td className={"text-end"}>
                            {parseFloat(product.qty_discount || 0).toFixed(2)}
                          </td>
                          <td className={"text-end"}>
                            {parseFloat(product.cash_discount || 0).toFixed(2)}
                          </td>
                          <td className={"text-end"}>
                            {parseFloat(product.special_discount || 0).toFixed(
                              2
                            )}
                          </td>
                          <td className={"text-end"}>
                            {numberFormat(product.amount)}
                          </td>
                        </tr>
                      ))}
                  </tbody>

                  <tfoot>
                    <tr>
                      <th colSpan={9}></th>
                      <th className={"text-end"}>Total</th>
                      <th className={"text-end"}>
                        {parseFloat(piData?.toatl_qty).toFixed(2)}
                      </th>
                      <th className={"text-end"}>
                        {numberFormat(piData?.total_gross)}
                      </th>
                      <th className={"text-end"}>
                        -{numberFormat(piData?.total_volume_discount)}
                      </th>
                      <th className={"text-end"}>
                        -{numberFormat(piData?.total_qty_discount)}
                      </th>
                      <th className={"text-end"}>
                        -{numberFormat(piData?.total_cash_discount)}
                      </th>
                      <th className={"text-end"}>
                        -{numberFormat(piData?.total_special_discount)}
                      </th>
                      <th className={"text-end"}>
                        {numberFormat(piData?.sub_total)}
                      </th>
                    </tr>
                  </tfoot>
                </RB.Table>
              </div>
            </RB.Row>

            <RB.Row className={"bg-white"}>
              <RB.Col
                md={9}
                className={"border border-top-0 order-sm-1 order-md-1 order-2"}
              >
                <RB.Row className={"border-bottom py-1"}>
                  <RB.Col>
                    <strong>Total in Words: {piData?.amount_in_word}</strong>
                  </RB.Col>
                </RB.Row>
                <RB.Row className={"border-bottom py-1"}>
                  <RB.Col className={"small"}>
                    Certified that the particular given above are true and
                    correct and the amounts indicated represent the prices
                    actually charged and that there is no flow of additional
                    consideration directly or indirectly from the buyer
                  </RB.Col>
                </RB.Row>

                <RB.Row className={"border-bottom py-2"}>
                  <RB.Col>
                    <strong>
                      Whether GST Payable Under Reverse Charge Mechanism: NO
                    </strong>
                    <ol className={"small mb-0"}>
                      <li>
                        Customer are requested to report any shortages, etc. in
                        the material received with in 15 days of material.
                      </li>
                      <li>
                        Interest @24% p.a. will be charged if the payment is not
                        received on or before the due date
                      </li>
                      <li>
                        Increase in the pride due to government control or
                        actions or any changes in the taxes, duties, impositions
                        by central, state or local authorities, shall be to
                        consumer's account.{" "}
                      </li>
                      <li>
                        Any disputes or differences relating to the order or in
                        connection with the terms conditions of sale, will be
                        subject to the jurisdiction of Courts only
                      </li>
                    </ol>
                  </RB.Col>
                </RB.Row>

                <RB.Row className={"py-1"}>
                  <RB.Col>
                    <strong>Terms and Conditions</strong>
                    <p className={"mb-1"} style={{ lineHeight: "normal" }}>
                      <small>
                        "we hereby certify that our registration Certificate
                        under the Goods and Service Tax, 2017 is in force on the
                        date on which the sale of the goods specified in this
                        tax invoice is executed and that the transaction of sale
                        covered by this tax invoice has been effected by us and
                        it shall be accounted for the turnover of the sale while
                        filling of return and the due tax, if any payable on the
                        sales has been paid or shall be paid"{" "}
                      </small>
                    </p>
                    <p className={"mb-1"} style={{ lineHeight: "normal" }}>
                      <small>
                        The Buyer is prohibited from doing business, either
                        directly or indirectly, with any and all
                        countries/region that the subject to embargo & sanctions
                        imposed by United Nations, European Union and/or the
                        United State of America (collectively the "Sanctioned
                        Countries"). The seller confirms to have discharged its
                        obligation to inform the buyer that engaging into
                        business transaction with Sanctioned Countries is
                        prohibited, and buyer confirms to be aware of the
                        aforementioned Obligations and agrees to support the
                        seller in the compliance with related regulations as
                        such.{" "}
                      </small>
                    </p>

                    {piData?.delivery_terms
                      ? piData?.delivery_terms
                          .split("\n")
                          .map(function (item, idx) {
                            return (
                              <p
                                className={"small mb-1"}
                                style={{ lineHeight: "normal" }}
                                key={idx}
                              >
                                {item}
                              </p>
                            );
                          })
                      : " "}
                  </RB.Col>
                </RB.Row>
              </RB.Col>
              <RB.Col md={3} className={"border order-md-2 order-sm-2 order-1"}>
                <RB.Row className={"border-bottom align-items-center"}>
                  <RB.Col xs={5} sm={5} md={5} className={"border-end py-1"}>
                    Net Amount
                  </RB.Col>
                  <RB.Col xs={7} sm={7} md={7} className={"text-end py-1"}>
                    <strong>{numberFormat(piData?.sub_total)}</strong>
                  </RB.Col>
                </RB.Row>

                <RB.Row className={"border-bottom align-items-center"}>
                  <RB.Col xs={5} sm={5} md={5} className={"border-end py-1"}>
                    Insurance{" "}
                    {piData?.insurance_per > 0
                      ? `(${piData?.insurance_per}%)`
                      : ""}
                  </RB.Col>
                  <RB.Col xs={7} sm={7} md={7} className={"text-end py-1"}>
                    <strong>
                      {numberFormat(
                        piData?.insurance_amount > 0
                          ? piData?.insurance_amount
                          : 0
                      )}
                    </strong>
                  </RB.Col>
                </RB.Row>
                <RB.Row className={"border-bottom align-items-center"}>
                  <RB.Col xs={5} sm={5} md={5} className={"border-end py-1"}>
                    Freight Amount (₹)
                  </RB.Col>
                  <RB.Col xs={7} sm={7} md={7} className={"text-end py-1"}>
                    <strong>
                      {numberFormat(
                        piData?.freight_amount > 0 ? piData?.freight_amount : 0
                      )}
                    </strong>
                  </RB.Col>
                </RB.Row>

                <RB.Row className={"border-bottom align-items-center"}>
                  <RB.Col xs={5} sm={5} md={5} className={"border-end py-1"}>
                    CGST
                  </RB.Col>
                  <RB.Col xs={7} sm={7} md={7} className={"text-end py-1"}>
                    <strong>{numberFormat(piData?.cgst)}</strong>
                  </RB.Col>
                </RB.Row>
                <RB.Row className={"border-bottom align-items-center"}>
                  <RB.Col xs={5} sm={5} md={5} className={"border-end py-1"}>
                    SGST
                  </RB.Col>
                  <RB.Col xs={7} sm={7} md={7} className={"text-end py-1"}>
                    <strong>{numberFormat(piData?.sgst)}</strong>
                  </RB.Col>
                </RB.Row>
                <RB.Row className={"border-bottom align-items-center"}>
                  <RB.Col xs={5} sm={5} md={5} className={"border-end py-1"}>
                    IGST
                  </RB.Col>
                  <RB.Col xs={7} sm={7} md={7} className={"text-end py-1"}>
                    <strong>{numberFormat(piData?.igst)}</strong>
                  </RB.Col>
                </RB.Row>
                <RB.Row className={"border-bottom align-items-center"}>
                  <RB.Col xs={5} sm={5} md={5} className={"border-end py-1"}>
                    TCS {piData?.tcs_per ? `(${piData?.tcs_per} %)` : ""}
                  </RB.Col>
                  <RB.Col xs={7} sm={7} md={7} className={"text-end py-1"}>
                    <strong>{numberFormat(piData?.tcs)}</strong>
                  </RB.Col>
                </RB.Row>
                <RB.Row className={"border-bottom align-items-center"}>
                  <RB.Col xs={5} sm={5} md={5} className={"border-end py-1"}>
                    Round Off
                  </RB.Col>
                  <RB.Col xs={7} sm={7} md={7} className={"text-end py-1"}>
                    <strong>{piData?.roundoff}</strong>
                  </RB.Col>
                </RB.Row>
                <RB.Row className={"border-bottom align-items-center bg-light"}>
                  <RB.Col xs={5} sm={5} md={5} className={"border-end py-1"}>
                    <strong>Invoice Total</strong>
                  </RB.Col>
                  <RB.Col xs={7} sm={7} md={7} className={"text-end py-1"}>
                    <strong>{numberFormat(piData?.main_total)}</strong>
                  </RB.Col>
                </RB.Row>
              </RB.Col>
            </RB.Row>
          </div>
        </RB.Card.Body>
      </RB.Card>

      {resStatus?.channel_partner_approve_status !== "1" &&
        resStatus?.channel_partner_approve_status !== "2" && (
          <RB.Card className={"card mx-5 mb-5 mt-2"}>
            <RB.CardHeader>
              <h6 className={"mb-0"}>Comment</h6>
            </RB.CardHeader>
            <RB.CardBody>
              <div>
                <RB.Col md={12} className="no-validation-icon">
                  <div className="mb-31">
                    {/*<RB.FloatingLabel
                    controlId="note"
                    className="floating-label-fancy"
                >*/}
                    <RB.Form.Control
                      as="textarea"
                      type="text"
                      placeholder="Enter your note here"
                      name="note"
                      value={note}
                      onChange={(e) => setNote(e.target.value)}
                      maxLength={500}
                      isInvalid={!!errors.note}
                      // required={status !== "1"}
                    />
                    <RB.Form.Control.Feedback type="invalid">
                      {errors.note}
                    </RB.Form.Control.Feedback>
                    {/*</RB.FloatingLabel>*/}
                  </div>
                </RB.Col>
              </div>
            </RB.CardBody>
            <RB.CardFooter className={"border-top"}>
              <RB.Button
                variant={"success"}
                className={"me-2"}
                onClick={handleAccept}
              >
                Accept
              </RB.Button>
              <RB.Button variant={"danger"} onClick={handleReject}>
                Reject
              </RB.Button>
            </RB.CardFooter>
          </RB.Card>
        )}
    </div>
  );
}

export default InvoicePage;
